import './../../scss/blocks/_modal.scss'
import {
    handleModalOpen,
    handleModalCloseButton,
    handleModalCloseEscapeButton,
    handleModalCloseBackground,
    bindRegistrationForms,
} from '../components/modalInit'

document.addEventListener('DOMContentLoaded', () => {
    if (document.documentElement.dataset.modalPopupBound === '1') {
        return
    }

    document.documentElement.dataset.modalPopupBound = '1'

    bindRegistrationForms(document)

    document.body.addEventListener('click', handleModalOpen)

    document.querySelectorAll('.js-modal').forEach((modal) => {
        modal.addEventListener('click', handleModalCloseBackground)
    })

    document.querySelectorAll('.modal-close').forEach((button) => {
        button.addEventListener('click', handleModalCloseButton)
    })

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            handleModalCloseEscapeButton()
        }
    })
})
